import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'

interface DevCentricInterface {
  isTab: boolean
  isMobile: boolean
}

const DevCentricProduct = ({ isTab, isMobile }: DevCentricInterface) => {
  const { headerSize, textSize } = useFontSize()
  const devProduct = require('../../assets/images/dev-product.png')

  return (
    <Box flexDirection={isMobile ? 'column' : 'row'} justify={'space-between'} pt={120}>
      <Box f={isMobile ? undefined : 1} align={isMobile ? 'center' : undefined}>
        <Image source={devProduct} height={isMobile ? 280 : 580} width={isMobile ? 240 : 500} resizeMode="cover" />
      </Box>
      <Box f={isMobile ? undefined : 1} justify={'center'} mt={isMobile ? 24 : 0}>
        <Text
          title={staticStrings.developerCen}
          fontFamily={'jiotype-black'}
          fontSize={headerSize}
          color={'BLACK_21'}
        />
        <Spacer size={isMobile ? 16 : 32} />
        <Box pr={isMobile ? 10 : isTab ? 32 : 180}>
          <Text
            title={staticStrings.developerCenPara}
            fontFamily={'jiotype-medium'}
            fontSize={textSize}
            lineHeight={isMobile ? 20 : 28}
            color={'BLACK_21'}
            opacity={0.9}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default DevCentricProduct
